import { IIconProps } from './add';

export const IcoLogOut = ({ style = {}, cy }: IIconProps) => {
  return (
    <svg
      className="icon-log-out"
      viewBox="0 0 48 48"
      style={style}
      data-cy={`LogoutIcon${cy}`}
    >
      <path
        fill="#FF1F1F"
        d="M18 40h-8c-0.552 0-1.050-0.222-1.414-0.586s-0.586-0.862-0.586-1.414v-28c0-0.552 0.222-1.050 0.586-1.414s0.862-0.586 1.414-0.586h8c1.104 0 2-0.896 2-2s-0.896-2-2-2h-8c-1.656 0-3.16 0.674-4.242 1.758s-1.758 2.586-1.758 4.242v28c0 1.656 0.674 3.16 1.758 4.242s2.586 1.758 4.242 1.758h8c1.104 0 2-0.896 2-2s-0.896-2-2-2zM37.172 22h-19.172c-1.104 0-2 0.896-2 2s0.896 2 2 2h19.172l-6.586 6.586c-0.782 0.782-0.782 2.048 0 2.828s2.048 0.782 2.828 0l10-10c0.184-0.184 0.332-0.404 0.434-0.648 0.3-0.724 0.156-1.59-0.434-2.18l-10-10c-0.782-0.782-2.048-0.782-2.828 0s-0.782 2.048 0 2.828z"
      ></path>
    </svg>
  );
};
